var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnhighlightedstar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68704 0.6343C7.96144 -0.210235 9.15623 -0.210233 9.43064 0.634302L10.8227 4.91858C10.9454 5.29627 11.2974 5.55198 11.6945 5.55198H16.1993C17.0872 5.55198 17.4565 6.6883 16.7381 7.21025L13.0936 9.85808C12.7723 10.0915 12.6379 10.5053 12.7606 10.8829L14.1527 15.1672C14.4271 16.0118 13.4605 16.714 12.7421 16.1921L9.09764 13.5443C8.77636 13.3108 8.34132 13.3108 8.02003 13.5443L4.37561 16.1921C3.6572 16.714 2.6906 16.0118 2.965 15.1672L4.35705 10.8829C4.47977 10.5053 4.34533 10.0915 4.02405 9.85808L0.379621 7.21025C-0.338783 6.6883 0.0304298 5.55198 0.918426 5.55198H5.42319C5.82031 5.55198 6.17227 5.29627 6.29499 4.91858L7.68704 0.6343Z",
    fill: "#EAEAEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnhighlightedstar);
export default __webpack_public_path__ + "static/media/unhighlightedstar.d01bfa87993084f6d6883170895abf90.svg";
export { ForwardRef as ReactComponent };